import { useHmoTarrif } from '@hook'
import { DeleteModal } from '@ui'
import { getError, showToast } from '@util'
import { useState } from 'react'

type Props = {
  id?: string
  onClose: () => void
}

export const RemoveTariff = ({ onClose, id }: Props) => {
  const { deleteTariff } = useHmoTarrif()
  const [isLoading, setIsLoading] = useState(false)

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await deleteTariff({ id: id || '' })
      onClose()
      showToast('Tariff deleted successfully')
      setIsLoading(false)
    } catch (error) {
      getError(error)
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <DeleteModal
      description="Confirm that you want to delete this Tariff"
      handleSubmit={handleDelete}
      isLoading={isLoading}
      onClose={onClose}
      title="Delete Tariff"
    />
  )
}
